import { CompanyUser } from '@/api';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { UIAvatar, UIText, UITooltip } from '@/ui';
import { useFormatDate } from '@/common/hooks';
import { useCompaniesTranslation } from '../hooks';

type UserInfoListItemProps = {
    user: CompanyUser;
};
export function UserInfoListItem(props: UserInfoListItemProps): ReactElement {
    const { user } = props;
    const { t } = useCompaniesTranslation();
    const { formatDateOnly } = useFormatDate();
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 8
            }}
        >
            <UIAvatar
                img={user.image}
                alt={
                    user.joined
                        ? `${user.firstName} ${user.lastName}`
                        : user.email
                }
                size={44}
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4
                }}
            >
                {user.joined ? (
                    <>
                        <UIText
                            medium
                        >{`${user.firstName} ${user.lastName}`}</UIText>
                        <UIText variant="small" type="default2">
                            {user.email}
                        </UIText>
                    </>
                ) : (
                    <>
                        <UIText medium>{user.email}</UIText>
                        <UITooltip
                            text={t(
                                'components.user_info_list_item.invited_on',
                                {
                                    date: formatDateOnly(
                                        new Date(user.invited?.at ?? '')
                                    )
                                }
                            )}
                            place="bottom"
                        >
                            <UIText variant="small" type="default2">
                                <Trans
                                    ns="companies"
                                    i18nKey="components.user_info_list_item.invited_by"
                                    values={{
                                        name: `${user.invited?.by?.firstName} ${user.invited?.by?.lastName}`
                                    }}
                                    components={{
                                        b: (
                                            <UIText
                                                variant="small"
                                                bold
                                                type="link"
                                            />
                                        )
                                    }}
                                />
                            </UIText>
                        </UITooltip>
                    </>
                )}
            </div>
        </div>
    );
}
